import { render } from "./resourceRecovery.vue?vue&type=template&id=7a7d73db&scoped=true"
import script from "./resourceRecovery.vue?vue&type=script&lang=js"
export * from "./resourceRecovery.vue?vue&type=script&lang=js"

import "./resourceRecovery.vue?vue&type=style&index=0&id=7a7d73db&scoped=true&lang=css"

import exportComponent from "/home/tyamada/ckan-ext-dev/yamanashi-dataplatform-admin-system-main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a7d73db"]])

export default __exports__